import React from "react";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "sonner";
import { AuthProvider, useAuth, FullScreenLoader } from "./lib/auth";
import { LangProvider } from "./lib/i18n";
import { ShopLayout } from "./components/ShopLayout";
import { AdminLayout } from "./components/AdminLayout";
import Landing from "./pages/Landing";
import Login from "./pages/Login";
import ForgotPassword from "./pages/ForgotPassword";
import ResetPassword from "./pages/ResetPassword";
import Dashboard from "./pages/shop/Dashboard";
import Customers from "./pages/shop/Customers";
import Items from "./pages/shop/Items";
import Loans from "./pages/shop/Loans";
import Repayments from "./pages/shop/Repayments";
import Alerts from "./pages/shop/Alerts";
import Auctions from "./pages/shop/Auctions";
import Finance from "./pages/shop/Finance";
import Warehouse from "./pages/shop/Warehouse";
import Reports from "./pages/shop/Reports";
import Settings from "./pages/shop/Settings";
import Audit from "./pages/shop/Audit";
import Messages from "./pages/shop/Messages";
import AdminDashboard from "./pages/admin/AdminDashboard";
import AdminShops from "./pages/admin/AdminShops";
import AdminPlans from "./pages/admin/AdminPlans";
import AdminPayments from "./pages/admin/AdminPayments";

function RequireShop({ children }) {
  const { user } = useAuth();
  if (user === null) return <FullScreenLoader />;
  if (!user) return <Navigate to="/login" replace />;
  if (user.role === "super_admin") return <Navigate to="/admin" replace />;
  return children;
}

function RequireAdmin({ children }) {
  const { user } = useAuth();
  if (user === null) return <FullScreenLoader />;
  if (!user) return <Navigate to="/login" replace />;
  if (user.role !== "super_admin") return <Navigate to="/app" replace />;
  return children;
}

function App() {
  return (
    <LangProvider>
      <AuthProvider>
        <BrowserRouter>
          <Routes>
            <Route path="/" element={<Landing />} />
            <Route path="/login" element={<Login />} />
            <Route path="/shop/:slug" element={<Login />} />
            <Route path="/forgot-password" element={<ForgotPassword />} />
            <Route path="/reset-password" element={<ResetPassword />} />
            <Route path="/app" element={<RequireShop><ShopLayout /></RequireShop>}>
              <Route index element={<Dashboard />} />
              <Route path="customers" element={<Customers />} />
              <Route path="items" element={<Items />} />
              <Route path="loans" element={<Loans />} />
              <Route path="repayments" element={<Repayments />} />
              <Route path="finance" element={<Finance />} />
              <Route path="alerts" element={<Alerts />} />
              <Route path="auctions" element={<Auctions />} />
              <Route path="warehouse" element={<Warehouse />} />
              <Route path="reports" element={<Reports />} />
              <Route path="settings" element={<Settings />} />
              <Route path="audit" element={<Audit />} />
              <Route path="messages" element={<Messages />} />
            </Route>
            <Route path="/admin" element={<RequireAdmin><AdminLayout /></RequireAdmin>}>
              <Route index element={<AdminDashboard />} />
              <Route path="shops" element={<AdminShops />} />
              <Route path="plans" element={<AdminPlans />} />
              <Route path="payments" element={<AdminPayments />} />
            </Route>
            <Route path="*" element={<Navigate to="/" replace />} />
          </Routes>
        </BrowserRouter>
        <Toaster richColors position="top-right" />
      </AuthProvider>
    </LangProvider>
  );
}

export default App;
